export const isValidProductionUnitIdentifier = (value: string): boolean => {
  const regex = /^\d{10}$/;
  return regex.test(value);
};
